import { Observable } from 'rxjs';
import {
  OrganizationMockMode,
  setOrganizationMockMode,
  getOrganizationMockMode$,
  getCurrentOrganizationMockMode
} from './data/organizations/mocked-organizations';
import {
  CommentMockMode,
  setCommentMockMode,
  getCommentMockMode$,
  getCurrentCommentMockMode
} from './data/comments/mocked-comments';
import {
  AuthMockMode,
  setAuthMockMode,
  getAuthMockMode$,
  getCurrentAuthMockMode
} from './data/auth/mocked-auth';
import {
  AppManagementMockMode,
  setAppManagementMockMode,
  getAppManagementMockMode$,
  getCurrentAppManagementMockMode
} from './data/app-management/mocked-app-management';

export interface MockDataCategory {
  id: string;
  label: string;
  icon: string;
  modes: MockDataMode[];
  currentMode$: Observable<string>;
  getCurrentMode: () => string;
  setMode: (mode: string) => void;
}
export interface MockDataMode {
  value: string;
  label: string;
  icon: string;
}

export const mockDataCategories: MockDataCategory[] = [
  {
    id: 'auth',
    label: 'Authentication',
    icon: '🔐',
    modes: [
      { value: 'logged-out', label: 'Logged Out', icon: '🔴' },
      { value: 'logged-in-user', label: 'Logged In (User)', icon: '🟡' },
      {
        value: 'logged-in-organization-admin',
        label: 'Logged In (Organization Admin)',
        icon: '🟢'
      },
      {
        value: 'logged-in-organization-representative',
        label: 'Logged In (Organization Representative)',
        icon: '🟢'
      },
      {
        value: 'logged-in-dataspace-authority',
        label: 'Logged In (Dataspace Authority)',
        icon: '🟢'
      }
    ],
    currentMode$: getAuthMockMode$(),
    getCurrentMode: () => getCurrentAuthMockMode(),
    setMode: (mode: string) => setAuthMockMode(mode as AuthMockMode)
  },
  {
    id: 'organizations',
    label: 'Organizations',
    icon: '👥',
    modes: [
      { value: 'empty', label: 'Empty', icon: '🔴' },
      { value: 'one', label: 'One Organization', icon: '🟡' },
      { value: 'multiple', label: 'Multiple Organizations', icon: '🟢' }
    ],
    currentMode$: getOrganizationMockMode$(),
    getCurrentMode: () => getCurrentOrganizationMockMode(),
    setMode: (mode: string) => setOrganizationMockMode(mode as OrganizationMockMode)
  },
  {
    id: 'comments',
    label: 'Comments',
    icon: '💬',
    modes: [
      { value: 'empty', label: 'No Comments', icon: '🔴' },
      { value: 'few', label: 'Few Comments', icon: '🟡' },
      { value: 'many', label: 'Many Comments', icon: '🟢' }
    ],
    currentMode$: getCommentMockMode$(),
    getCurrentMode: () => getCurrentCommentMockMode(),
    setMode: (mode: string) => setCommentMockMode(mode as CommentMockMode)
  },
  {
    id: 'app-management',
    label: 'App Management',
    icon: '📦',
    modes: [
      { value: 'no-use-cases', label: 'No Use Cases', icon: '🔴' },
      { value: 'all-use-cases', label: 'All Use Cases', icon: '🟢' }
    ],
    currentMode$: getAppManagementMockMode$(),
    getCurrentMode: () => getCurrentAppManagementMockMode(),
    setMode: (mode: string) => setAppManagementMockMode(mode as AppManagementMockMode)
  }
];
